module.exports = __webpack_public_path__ + "img/lg-metal-brackets-set.c8a93743.png";